export const photoEnlargementHash = 'bigger-photos'
